import useVideoThumbnails from "../../../../../hooks/useVideoThumbnails";

/**
 * Hook to generate thumbnails for videos with error handling and retry limits
 * @param {Array} videos - Array of video objects with url and id properties
 * @param {Object} options
 * @param {string|null} options.organizationId - Used to refresh stale messageGroups Storage URLs
 * @returns {Object} - Object containing thumbnail URLs indexed by video ID, loading state, and refresh function
 */
const useThumbnailGenerator = (videos = [], options = {}) => {
  const { organizationId = null } = options;

  const { thumbnails, loadingThumbnails, generateThumbnails } =
    useVideoThumbnails(videos, {
      lazy: false,
      maxRetries: 2,
      retryDelay: 1000,
      loadTimeout: 10000,
      concurrency: 3,
      organizationId,
    });

  return {
    thumbnails,
    loadingThumbnails,
    generateThumbnails,
  };
};

export default useThumbnailGenerator;
